import { IconNames } from '~types/icon'
import { Routes, BottomTabRouteName } from '~types/routesNames'

export const getNavigationTabIconName = ({
  routeName,
  focused,
}: {
  routeName: BottomTabRouteName
  focused: boolean
}): IconNames => {
  const iconType: 'fill' | 'line' = focused ? 'fill' : 'line'
  const iconNames: { [key in BottomTabRouteName]: IconNames } = {
    [Routes.OffersStack]: `vip-diamond-${iconType}`,
    [Routes.HistoryStack]: `history-${iconType}`,
    [Routes.UserStack]: `user-${iconType}`,
  }
  return iconNames[routeName]
}
